// import * as common from '@/store/mutation-types';

export const SEARCH_PARAM = 'SEARCH_PARAM';
export const USER_LIST = 'USER_LIST';
export const PAGING_INFO = 'PAGING_INFO';
export const DEFAULT_ASSIGN = 'DEFAULT_ASSIGN';

export default {
	// ...common,
	SEARCH_PARAM,
	USER_LIST,
	PAGING_INFO,
	DEFAULT_ASSIGN
};
